<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <div
      
      class="mt-2 reg-tab-container"
    >
      <p class="reg-heading-tab">Summary</p>
      <div class="reg-form-body">
        <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Personal Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.PersonalDetail"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.PersonalDetail"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div>
        <br>
        <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Address Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.AddressDetail"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.AddressDetail"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div>
        <!-- <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Physical Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.PhysicalDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.PhysicalDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>-->
        <!-- <br />
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Nominee Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.NomineeDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.NomineeDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>-->
        <br/>
                    <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Family Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.FamilyDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.FamilyDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>
        <br />
        <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Bank Account Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.BankAccount" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.BankAccount" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>
                  <!--   <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Experience Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.ExprienceDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.ExprienceDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
                        <br/>
        </div>-->

        <!-- <div class="row justify-content-md-center">
                        <div class="col-6 col-md-3 ">
                            Qualification Details
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.QualificationDetail" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.QualificationDetail" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>-->
        <br>
        <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Lending Loan Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.LendingLoan"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.LendingLoan"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div>
        <br>
        <!-- <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Bank Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.BankDetails"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.BankDetails"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div>
        <br> -->
        <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Document Upload Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.DocumentUpload"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.DocumentUpload"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div>
         <br>
        <div class="row justify-content-md-center">
          <div class="col-6 col-md-3">Decleration Details</div>
          <div class="col-1 col-md-1">
            <i
              class="far fa-times-circle"
              v-if="!form.DeclerationDetail"
              style="font-size:20px;color:red"
            ></i>
            <i
              class="far fa-check-circle"
              v-if="form.DeclerationDetail"
              style="font-size:20px;color:green"
            ></i>
          </div>
        </div> 
        <!-- <br />
                    <div class="row justify-content-md-center" style="display:none">
                        <div class="col-6 col-md-3 ">
                            Payment Status 
                        </div>
                        <div class="col-1 col-md-1">
                            <i class="far fa-times-circle" v-if="!form.PaymentStatus" style="font-size:20px;color:red"></i>
                            <i class="far fa-check-circle" v-if="form.PaymentStatus" style="font-size:20px;color:green"></i>
                            
                        </div>
        </div>-->
         <br />
        <div class="row justify-content-md-center">
          <b-button type="submit" v-if="!saved && isComplete"  @click="onSubmit1" variant="primary">Submit Application</b-button>
        </div>
        <br>
      </div>
      <b-button
        size="sm"
        @click.stop="applyforScheme($event.target,4)"
        class="mr-1 pt-0 pb-0"
        variant="outline-danger"
        v-b-tooltip.hover
        title="View Details"
      >View/Print Profile</b-button>
    </div>
    <b-modal
      ref="confirmApply"
      id="modalConfirm12345"
      centered
      hide-footer
      title="Alert!"
      size="sm"
    >
      <p>I confirm that I or any of my family members have not taken benefit of any scheme of the board.</p>
      <hr>
      <div class="justify-content-md-center">
        <b-btn class="float-right" size="sm" variant="primary" @click="onSubmit">Yes</b-btn>
      </div>
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="modalCancel">No</b-btn>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  components: { Spinner },
  data() {
    return {
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      saved:false,
      isComplete:false,
      form: {
        PersonalDetail: false,
        AddressDetail: false,
        PhysicalDetail: false,
        NomineeDetail: false,
        FamilyDetail: false,
        ExprienceDetail: false,
        QualificationDetail: false,
        DocumentUpload: false,
        DeclerationDetail: false,
        PaymentStatus: false,
        LendingLoan: false,
        BankDetails: false,
        BankAccount:false,
        LoginID:"",
        LoanType:"",
        isComplete:false,
        LoanApplication:[{
          LoanType:"",
          UserID:"",
          SchemeType:"",
          LoanDistrict:""
        }]
      },
      formSave:{
          LoanType:"",
          UserID:"",
          SchemeType:"",
          LoanDistrict:"",
          UserID:""
        }
    };
  },
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      return x;
    },
    getScheme() {
      let x = this.$store.getters.getScheme;
      //console.log (x);
      return x;
    }
  },
  methods: {
    CheckStatus() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then(response => {
          if (response.status == 200) {
            this.form = response.body;

            if(this.form.PersonalDetail && this.form.AddressDetail &&
                this.form.BankAccount && this.form.FamilyDetail &&
                this.form.LendingLoan && this.form.DocumentUpload &&
                this.form.DeclerationDetail
              ){
                this.isComplete = true;
              }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    modalCancel() {
      this.$root.$emit("bv::hide::modal", "modalConfirm12345");
    },
    onSubmit1(evt) {
      this.$root.$emit("bv::show::modal", "modalConfirm12345");
    },
    onSubmit(evt) {
     this.$root.$emit("bv::hide::modal", "modalConfirm12345");
      
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.formSave.UserID = userinfo.UserId;
      //this.form.LoanType = this.$store.getters.getScheme.LoanType;
      this.formSave.LoanType = this.$store.getters.getScheme.LoanType;
      this.formSave.SchemeType = this.$store.getters.getScheme.SchemeID;
      this.formSave.LoanDistrict = this.$store.getters.getLoanDistrict;
      this.formSave.LoanApplicationID = this.$store.getters.getApplicationID;
      let promise = apis.saveLoanApplication(this.formSave);

      promise
        .then(response => {
          if (response.status == 200) {
            // if(response.body===99)
            // {
            //   this.alertText = "Application already submited please visit dashboard for Application No.";
            // }
            // if(response.body===2)
            // {
            //   this.alertText = "Data Submitted Please click on the view/Print Profile for Application";

            // }
            this.alertText = response.body;
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    applyforScheme(button, n) {
      if (this.$store.getters.getScheme.LoanType == 2) {
        this.$router.push("/ViewGroupDetails");
      } else {
        this.$router.push("/ViewPresonalDetails");
      }
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.CheckStatus();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Summary.vue